import { useRef } from 'react';

export function useVietnameseInput() {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Vietnamese input handling logic could go here
    // For now, just pass through
    console.log(e)
  };

  return {
    inputRef,
    handleInputChange,
  };
}
